import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Avatar } from '@mui/material';

// import Hero from './Hero.tsx'

interface AppLocation {
  text: string;
  url: string;
}

const drawerWidth = 240;
const navItems = [{text: 'Home', url: "/"}, {text: 'Our Story', url: "/about"}, {text: 'Venue', url: "/venue"}, {text: 'Accomodations', url: "/hotels"}, {text: 'Schedule & Details', url: "/details"}, {text: 'Registry', url: "/registry"}, {text: 'RSVP', url: "/rsvp"}] as AppLocation[];
const listItems = navItems.map((item) => (
  <ListItem key={item.text} disablePadding>
    <ListItemButton href={item.url} sx={{ textAlign: 'center' }}>
      <ListItemText primary={item.text} />
    </ListItemButton>
  </ListItem>
));

export default function WeddingAppBar() {
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center'}}>
      <Typography  sx={{ my: 2 }}>
        Court and Andrew
      </Typography>
      <Divider />
      <List>
      {navItems.map((item) => (
        <ListItem key={item.text} disablePadding>
          <ListItemButton href={item.url} sx={{ textAlign: 'center' }}>
            <ListItemText primary={item.text} />
          </ListItemButton>
        </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <Box sx={{ display: 'flex', px: 0 }}>
      <CssBaseline />
      <AppBar component="nav"> 
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <Avatar sx={{backgroundColor: "#ffeedd", color: "darkred"}}>
              <MenuIcon />
            </Avatar>
            <Typography sx={{ml: 2}}>Menu</Typography>
          </IconButton>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            {navItems.map((item) => (
              <Button key={item.text} href={item.url} sx={{ color: '#fff' }}>
                {item.text}
              </Button>
            ))}
          </Box>
        </Toolbar>
      </AppBar>
      <nav>
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ 
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
    </Box>
  );
}